skrilla.controller('createPromotionCodeModal', function ($scope, searchService, modalService, validationService, cacheService, queryService, moment, constantsService, srefService) {
    $scope.query = queryService.normaliseQueryObject(cacheService.getObject("queryUsers" + constantsService.getUsersPageKey()));
    $scope.validate = {}
    $scope.request = {
        userClaimable:false,
        code:  null
    }

    searchService.get("promotions/definitions").then(function (response) {
        $scope.definitions = response.data.result;
    })

    $scope.select = function(definition){
        $scope.selectedDefinition = definition;
        const suffix = moment().format('YYYYMMDDHHMM');
        $scope.request.code = definition.purpose + "_" + (definition.claimerAmount / 100) + definition.currency + "_" + suffix;
    }

    $scope.create = function(){
        modalService.confirm("Are you sure you'd like to create this code?", function () {
            const request = {
                ...$scope.request,
                queryUsers: {...$scope.query,
                    maximumPlatformBalance: $scope.maximumPlatformBalance && $scope.maximumPlatformBalance * 100,
                    maximumPromotionBalance: $scope.maximumPromotionBalance && $scope.maximumPromotionBalance * 100,
                }
            };
            searchService.post("promotions/definitions/" + $scope.selectedDefinition.id + "/codes", request).then(function (response) {
                modalService.dismissAll();
                srefService.go("promotionCodeAndClaims", {id: response.data.id})
            })
        });
    }

});
